/** Retire les blancs et adoucit leurs contours sans modifier les couleurs foncées. */
export function makeLogoWhiteTransparent(pixels) {
  let changed = false;
  for (let offset = 0; offset < pixels.length; offset += 4) {
    const minimum = Math.min(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
    const maximum = Math.max(pixels[offset], pixels[offset + 1], pixels[offset + 2]);
    if (!pixels[offset + 3] || minimum <= 225 || maximum - minimum > 20) continue;
    const opacity = Math.max(0, (250 - minimum) / 25);
    // Décontamine les contours clairs pour éviter un liseré blanc sur fond coloré.
    for (let channel = 0; channel < 3; channel++) {
      pixels[offset + channel] = opacity ? Math.max(0, (pixels[offset + channel] - 255 * (1 - opacity)) / opacity) : 0;
    }
    pixels[offset + 3] = Math.round(pixels[offset + 3] * opacity);
    changed = true;
  }
  return changed;
}

export async function transparentBillingLogo(logoUrl) {
  const image = new Image();
  image.src = logoUrl;
  await image.decode();
  const canvas = document.createElement("canvas");
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Impossible de préparer le logo transparent dans ce navigateur.");
  context.drawImage(image, 0, 0);
  const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
  if (!makeLogoWhiteTransparent(imageData.data)) throw new Error("Aucune zone blanche à rendre transparente dans ce logo.");
  context.putImageData(imageData, 0, 0);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!blob) throw new Error("Le logo transparent n’a pas pu être préparé.");
  return new File([blob], "logo-transparent.png", { type: "image/png" });
}
